var React = require('react');

function ProcessingIconMini (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#0468FF","strokeWidth":"150","d":"M400 500c300 0 300-400 0-400","key":0}),React.createElement("path",{"stroke":"#1F34AB","strokeWidth":"150","d":"M400 200 100 600","key":1}),React.createElement("path",{"stroke":"#85AEFF","strokeWidth":"150","d":"m100 300 100 200","key":2})]);
}

ProcessingIconMini.defaultProps = {"fill":"none","viewBox":"10 -10 710 690"};

module.exports = ProcessingIconMini;

ProcessingIconMini.default = ProcessingIconMini;
